import styled from "styled-components"
import child_request from "../assets/images/child_request.svg";
import {
    CustomButton,
    BackButton,
    Modal,
    CustomInput,
    GameResultCard
} from "../components"
import lion_avatar from "../assets/images/lion_avatar.svg";
import { COLORS, avatars } from "../constants";

import {
    checkPasswordMatch,
    validatePassword,
    validateChildPassword
} from '../features'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import { Row, Col } from "reactstrap"
import { Link, useHistory } from "react-router-dom";
import { levelcolors } from "../constants/levelcolors"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useState } from "react";
import Camera from "../assets/images/camera.svg"
import axios from "axios"
import ReactLoading from "react-loading"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const StyledCTA = styled.div`
    background: white;
    padding: 10px 20px;
    height: 45px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    color: #D95F6C;
    cursor: pointer;
    transition: box-shadow 0.2s cubic-bezier(0.55, 0.055, 0.675, 0.19);

    &:hover{
        box-shadow: none !important;
    }
`;
const StyledAvatarContainer = styled.div`

    display: block;
    display: -webkit-box;
    text-align: center;
   

    margin-top: 20px;

`;
const StyledImage = styled.img`
    cursor: pointer;
    flex-shrink: 0;

    transition: all 0.2s;

    &:hover{
        transform: scale(0.9)
    }
`;
const StyledCamera = styled.div`
    position: absolute;
    right: 0; 
    bottom: 2px; 
    background-color: white; 
    border-radius: 50%; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    width: 30px; 
    height: 30px;
    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    cursor: pointer;
`;
const StyledSeeAll = styled(Link)`
    color: black;
    transition: color 0.2s;
    &:hover{
        color: ${COLORS.green};
    }
`;
function ChildResults(props) {
    const { id } = props.match.params;
    const api = process.env.REACT_APP_API_URL;
    const history = useHistory();
    const user = useSelector(state => state.auth.user.user);
    const [levelResults, setLevelResults] = useState([]);
    const [childDetails, setChildDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [pupilWords, setPupilWords] = useState(0);
    const [error, setError] = useState(false);
    const [visible, setVisible] = useState(false);
    const [confirmationVisible, setConfirmationVisible] = useState(false);
    const [avatarModalVisible, setAvatarModalVisible] = useState(false);
    const [avatarID, setAvatarID] = useState(-1);
    const [childResultGames, setChildResultGames] = useState([])
    const [childCurrentPassword, setChildCurrentPassword] = useState('');
    const [emptyError, setEmptyError] = useState('');
    //Details
    const [password, setPassword] = useState("")
    const [oldPassword, setOldPassword] = useState("")
    const [passwordRepeat, setPasswordRepeat] = useState("")
    const [passwordError, setPasswordError] = useState("");
    const [passwordMatchError, setPasswordMatchError] = useState("")
    const [server, setServer] = useState("");
    const [certificatesVisible, setCertificatesVisible] = useState(false);
    useEffect(async () => {
        const response = await axios.get(`${api}/cp/total_words/${id}`);
        const data = response.data;

        setPupilWords(data.total_words_learned)

    }, [])

    const updateAvatar = async (avatar_id) => {
        setAvatarModalVisible(false);
        const response = await axios.post(`${api}/cp/update_avatar`, { pupil_id: id, avatar_id: avatar_id });
        const data = response.data;

        if (data.status_code == 1) {
            setAvatarID(avatar_id)
        }
    }
    useEffect(async () => {
        async function fetchdata() {
            const response = await axios.get(`${api}/cp/pupil_password/${id}`);
            setChildCurrentPassword(response.data.password)
        }
        fetchdata();
    }, [childCurrentPassword])

    useEffect(() => {

        axios.get(`${api}/cp/pupil/${id}`, {}, {
        }).then(res => {

            const result = res.data.pupil_id[0];
            setChildDetails(result);
            setAvatarID(result.avatar_id)

            if (!result) {
                setLoading(false);
            } else if (result.pt_email == user.email) {

                axios.get(`${api}/cp/last_game_set/${id}`, {}, {
                }).then(res => {

                    const result = res.data;
                    setLevelResults(result.last_game_set);
                    setLoading(false);
                    console.log(result)
                    if (result.status_code == 0) {
                        setEmptyError(result.message)
                    }

                }).catch(error => {
                    setLoading(false);

                });

            } else {
                setError(true)
                setLoading(false);
            }

        }).catch(error => {
            console.log(error)
        });


    }, [])
    const updateData = async () => {
        setSubmitLoading(true)
        if (validateChildPassword(password)) {
            if (checkPasswordMatch(password, passwordRepeat)) {
                const response = await axios.post(`${api}/cp/reset_password`, { email_id: user.email, pupil_id: id, new_password: password });
                const data = response.data;
                if (data.status == "success") {
                    toast("Password Changed Successefully");
                    setVisible(false);
                    setChildCurrentPassword(password);

                } else {
                    setServer(data.message);
                }
                setSubmitLoading(false)
            } else {
                setSubmitLoading(false)
                setPasswordMatchError('Passwords do not match')
            }

        } else {
            setSubmitLoading(false)
            setPasswordError('Check the password')
        }

    }
    const deleteAccount = async () => {
        setDeleteLoading(true);
        try {
            const response = await axios.post(`${api}/cp/delete_account`, { email_id: user.email, pupil_id: id });
            const data = response.data;
            if (data) {
                setDeleteLoading(false);
                setConfirmationVisible(false);
                // toast("Account Deleted Successefully");
                window.location.replace('/dashboard')


            }
        } catch (error) {
            setDeleteLoading(false)
        }
    }
    const clearData = () => {
        setTimeout(() => {
            setPasswordError('');
            setPasswordRepeat('');
            setPassword('')
            setPasswordMatchError('')
        }, 200)
    }
    const loginToChild = () => {

        history.replace('/transfer', { uid: id, password: childCurrentPassword });


    }
    if (loading) {
        return <div>
            <BackButton to="/dashboard" />
            <h5 className="text-center color-text-green">Loading...</h5>
        </div>
    }
    else if (typeof (childDetails) == "undefined" || error) {
        return <div>
            <BackButton to="/dashboard" />
            <h5 className="text-center color-text-green">Child Not Found</h5>
        </div>

    } else {
        return (
            <div>

                <BackButton to="/dashboard" />
                {/* <div className="d-flex justify-content-center align-items-center flex-wrap">

                    <StyledCTA className="shadow-md">
                        <img src={child_request} className="mr-1" />
                    This child requested more games!
                </StyledCTA>
                </div> */}
                <div className="w-100 bg-white p-3 text-center-sm mt-3" style={{ borderRadius: 10 }}>
                    <Row>
                        <Col md={2} className="mt-2 mb-2 d-flex justify-content-center align-items-center">
                            {avatarID == -1 ? <div style={{ width: 100, height: 100 }} /> :
                                <div style={{ position: "relative", width: "100%", maxWidth: 100 }} onClick={() => setAvatarModalVisible(true)}>
                                    <img src={avatars[avatarID].image} style={{ cursor: "pointer", width: "100%", maxWidth: 100 }} />
                                    <StyledCamera>
                                        <img src={Camera} width="20" />
                                    </StyledCamera>
                                </div>
                            }
                        </Col>
                        <Col md={9} className="d-flex flex-column justify-content-center mt-2 mb-2">
                            {childDetails && <h5 className="color-text-dark-blue m-0">{childDetails.first_name + " " + childDetails.last_name}</h5>}
                            <div>
                                <span className="d-inline-block mr-1">Learned Words</span>
                                <span className="color-text-grey">•</span>
                                {childDetails && <span className="ml-1 color-text-green d-inline-block" style={{ fontSize: 20 }}>{pupilWords}</span>}
                                <span className="d-inline-block ml-2 mr-1">ID</span>
                                <span className="color-text-grey">•</span>
                                {childDetails && <span className="ml-1 color-text-green d-inline-block" style={{ fontSize: 20 }}>{childDetails.id}</span>}

                            </div>
                            <div>
                                <span className="d-inline-block mr-1">Password</span>
                                <span className="color-text-grey">•</span>
                                {childDetails && <span className="ml-1 color-text-green d-inline-block" style={{ fontSize: 20 }}>{childCurrentPassword}</span>}
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={2}>
                        </Col>
                        <Col md={9}>
                            <div className="d-flex w-100">
                                <CustomButton className="mr-1" onClick={() => setConfirmationVisible(true)} bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 43, padding: "0 10px", fontSize: 14 }}>Delete Account</CustomButton>
                                <CustomButton className="mx-1" onClick={() => setVisible(true)} bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.text_green} style={{ height: 43, padding: "0 10px", fontSize: 14 }}>Change Password</CustomButton>
                                <CustomButton className="ml-1 mr-1" onClick={loginToChild} bgColor={COLORS.orange} color={COLORS.dark_orange} hover={COLORS.orange_hover} style={{ height: 43, padding: "0 10px", fontSize: 14 }}>Log In</CustomButton>
                                <CustomButton className="ml-1" onClick={() => history.push(`/dashboard/child/${id}/certificates`)} bgColor={COLORS.green} color={COLORS.text_dark_green} hover={COLORS.text_green} style={{ height: 43, padding: "0 10px", fontSize: 14 }}>Certificates</CustomButton>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="w-100 bg-white mt-3 pl-3 pt-3 pb-4 pr-3" style={{ borderRadius: 10 }}>
                    <h5 className="color-text-blue mb-0">Child Progress</h5>
                    <div className="color-text-grey mb-3">Review your child's latest results</div>
                    {emptyError && <div className="mt-4 color-text-green">{emptyError}</div>}

                    <div>
                        {levelResults.map((level, i) => {
                            return <div key={i}>
                                {level.length != 0 && <div className="d-flex justify-content-between">
                                    <h6 className="mt-2" style={{ fontSize: 18, color: levelcolors[i].bgColor, display: "inline-block" }}>Level {i + 1}</h6>
                                    <StyledSeeAll to={`/dashboard/child/${id}/games/${i + 1}`}>See All</StyledSeeAll>
                                </div>
                                }

                                <Swiper slidesPerView="auto" style={{ marginLeft: "-5px" }}>
                                    {level.map((game, j) => {
                                        return <SwiperSlide key={j} style={{ width: 170 }}>
                                            <GameResultCard date={game.end_date_time} key={j} gameNumber={game.game_no} score={game.score} colorScore={levelcolors[i].bgColor} colorMaxScore={levelcolors[i].color} />
                                        </SwiperSlide>
                                    })}
                                </Swiper>


                            </div>
                        })}
                    </div>
                    <ToastContainer position="bottom-center" pauseOnHover={false} autoClose={2000} />
                </div>


                <Modal modalVisible={avatarModalVisible} onClose={() => setAvatarModalVisible(false)}>
                    <div className="p-3">
                        <h4 className="text-center color-text-green">Change Avatar</h4>
                        <StyledAvatarContainer>
                            {avatars.map((image, i) => {
                                return <StyledImage key={i} src={image.image} width="150" className="m-1 avatar" onClick={() => updateAvatar(i)} />
                            })}
                        </StyledAvatarContainer>
                    </div>
                </Modal>
                <Modal modalVisible={visible} width="40%" onClose={() => {
                    setVisible(false);
                    clearData();
                }}>
                    <h5 className="color-text-dark-blue">Change Password</h5>

                    <Row>

                        <Col lg={6} className="mt-3">
                            <h6>New Password</h6>
                            <CustomInput name="password" className="w-100" type="password" value={password} onChange={(e) => {
                                setPassword(e.target.value)
                                setPasswordError('')
                                setPasswordMatchError('')
                                setServer('')
                            }} />
                        </Col>
                        <Col lg={6} className="mt-3">
                            <h6>Repeat New Password</h6>
                            <CustomInput name="passwordrepeat" className="w-100" type="password" value={passwordRepeat} onChange={(e) => {
                                setPasswordRepeat(e.target.value)
                                setPasswordError('')
                                setPasswordMatchError('')
                                setServer('')
                            }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={{ fontSize: 14 }} className="color-text-grey">Password should contain at least 5 lowercase letters</div>
                        </Col>
                    </Row>
                    <Row className="mx-0 mt-3">

                        <div className="text-left" style={{ fontSize: 14, color: "red" }}>{passwordError}</div>
                        {server && <div className="text-left" style={{ fontSize: 14, color: "red" }}>{server}</div>}
                        <div style={{ fontSize: 14, color: "red" }}>{passwordMatchError}</div>

                    </Row>
                    <div className="d-flex justify-content-between mt-3">
                        <CustomButton
                            bgColor={COLORS.orange}
                            hover={COLORS.orange_hover}
                            color={COLORS.dark_orange}

                            onClick={() => {
                                clearData();
                                setVisible(false);
                            }}
                            style={{ padding: "0 40px", height: 50, fontSize: 16 }}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            bgColor={COLORS.green}
                            hover={COLORS.darker_green}
                            color={COLORS.text_dark_green}
                            disabled={submitLoading}
                            onClick={updateData}
                            style={{ padding: "0 40px", height: 50, fontSize: 16 }}
                        >
                            {submitLoading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Submit'}
                        </CustomButton>
                    </div>
                </Modal>
                <Modal modalVisible={confirmationVisible} width="30%" onClose={() => setConfirmationVisible(false)}>
                    <h5 className="color-text-dark-blue">Delete Account</h5>
                    Are you sure you would like to delete {childDetails.first_name + " " + childDetails.last_name} account?
                    <div className="d-flex justify-content-between mt-3">
                        <CustomButton
                            bgColor={COLORS.orange}
                            hover={COLORS.orange_hover}
                            color={COLORS.dark_orange}

                            onClick={() => setConfirmationVisible(false)}
                            style={{ padding: "0 40px", height: 50, fontSize: 16 }}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            bgColor={COLORS.green}
                            hover={COLORS.darker_green}
                            color={COLORS.text_dark_green}
                            disabled={submitLoading}
                            onClick={deleteAccount}
                            style={{ padding: "0 40px", height: 50, fontSize: 16 }}
                        >
                            {deleteLoading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Delete'}
                        </CustomButton>
                    </div>
                </Modal>
                {/* <Modal modalVisible={certificatesVisible} width="60%" onClose={() => setCertificatesVisible(false)}>
                    <h5 className="color-text-dark-blue">Print Certificates</h5>

                </Modal> */}
            </div >
        );
    }
}

export default ChildResults;